import React, { useState } from "react";
import api from "../common/apiClient";
import SummaryAPI from "../common/SummaryApi";

const BannerForm = ({ onSuccess }) => {
  const [image, setImage] = useState(null);
  const [category, setCategory] = useState("womens");

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!SummaryAPI.createBanner) {
    console.error("createBanner API not found in SummaryAPI");
    return;
  }

  const formData = new FormData();
  formData.append("image", image);
  formData.append("topCategorySlug", category);

  await api({
    method: SummaryAPI.createBanner.method,
    url: SummaryAPI.createBanner.url,
    data: formData
  });

  setImage(null);
  onSuccess();
};


  return (
    <form onSubmit={handleSubmit} className="bg-white p-4 rounded shadow space-y-4">
      <h2 className="font-medium">Add New Banner</h2>

      <select
        className="border p-2 w-full"
        value={category}
        onChange={(e) => setCategory(e.target.value)}
      >
        <option value="womens">Womens</option>
        <option value="men">Mens</option>
        <option value="kids">Kids</option>
      </select>

      <input
        type="file"
        accept="image/*"
        onChange={(e) => setImage(e.target.files[0])}
        required
      />

      <button className="bg-blue-600 text-white px-4 py-2 rounded">
        Upload Banner
      </button>
    </form>
  );
};

export default BannerForm;
